import React, { useEffect } from 'react'

export default function Lightbox({ images, currentIndex, onClose, onPrev, onNext }) {
  useEffect(() => {
    function handleKeyDown(e) {
      if (e.key === 'Escape') onClose()
      if (e.key === 'ArrowLeft') onPrev()
      if (e.key === 'ArrowRight') onNext()
    }
    window.addEventListener('keydown', handleKeyDown)
    // Prevent background scrolling when open
    document.body.style.overflow = 'hidden'
    return () => {
      window.removeEventListener('keydown', handleKeyDown)
      document.body.style.overflow = ''
    }
  }, [onClose, onPrev, onNext])

  if (currentIndex === null || !images || images.length === 0) return null

  const currentImage = images[currentIndex]

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/95 backdrop-blur-sm animate-in fade-in duration-200">
      {/* Close Button */}
      <button 
        onClick={onClose}
        className="absolute top-4 right-4 z-50 p-3 text-white/80 hover:text-white hover:bg-white/10 rounded-full transition-all focus:outline-none cursor-pointer"
        aria-label="Luk"
      >
        <i className="fa-solid fa-xmark text-2xl"></i>
      </button>

      {/* Navigation Buttons */}
      <button 
        onClick={onPrev}
        className="absolute left-4 z-50 p-4 text-white/80 hover:text-white hover:bg-white/10 rounded-full transition-all focus:outline-none cursor-pointer hidden sm:flex items-center justify-center"
        aria-label="Forrige billede"
      >
        <i className="fa-solid fa-chevron-left text-2xl"></i>
      </button>

      <button 
        onClick={onNext}
        className="absolute right-4 z-50 p-4 text-white/80 hover:text-white hover:bg-white/10 rounded-full transition-all focus:outline-none cursor-pointer hidden sm:flex items-center justify-center"
        aria-label="Næste billede"
      >
        <i className="fa-solid fa-chevron-right text-2xl"></i>
      </button>

      {/* Main Image Container */}
      <div className="relative max-w-[90vw] max-h-[80vh] flex flex-col items-center select-none">
        <img 
          src={currentImage.image[0]} 
          alt={currentImage.title}
          className="max-w-full max-h-[75vh] object-contain rounded-none shadow-2xl animate-in zoom-in-95 duration-200"
        />
        {currentImage.title && (
          <div className="mt-4 text-center text-white font-medium text-base sm:text-lg bg-black/40 px-4 py-1.5 rounded-full">
            {currentImage.title}
          </div>
        )}
      </div>

      {/* Mobile Swipe / Touch Navigation Helpers */}
      <div className="absolute bottom-4 left-1/2 -translate-x-1/2 flex items-center gap-6 sm:hidden z-50">
        <button 
          onClick={onPrev}
          className="p-3 bg-white/10 text-white rounded-full active:bg-white/20"
          aria-label="Forrige"
        >
          <i className="fa-solid fa-chevron-left text-lg"></i>
        </button>
        <span className="text-white/60 text-sm font-medium">
          {currentIndex + 1} / {images.length}
        </span>
        <button 
          onClick={onNext}
          className="p-3 bg-white/10 text-white rounded-full active:bg-white/20"
          aria-label="Næste"
        >
          <i className="fa-solid fa-chevron-right text-lg"></i>
        </button>
      </div>
    </div>
  )
}
